import { render } from "./order-form.vue?vue&type=template&id=0cfc960c"
import script from "./order-form.vue?vue&type=script&lang=js"
export * from "./order-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__